import React from 'react';

const Section = ({ title, children }) => (
  <div style={{ marginBottom: 32 }}>
    <h2 style={{ fontSize: 20, fontWeight: 700, marginBottom: 12, color: '#111' }}>{title}</h2>
    <div style={{ color: '#374151', lineHeight: 1.8, fontSize: 15 }}>{children}</div>
  </div>
);

export default function TermsOfService() {
  return (
    <div className="container" style={{ maxWidth: 820 }}>
      <h1 style={{ marginBottom: 6 }}>Terms of Service</h1>
      <p style={{ color: '#6b7280', marginBottom: 36 }}>Last updated: July 2026</p>

      <Section title="1. Acceptance of Terms">
        <p>By accessing and using StyleMe (styleme.club), you agree to be bound by these Terms of Service. If you do not agree to these terms, please do not use our website.</p>
      </Section>

      <Section title="2. Products and Pricing">
        <ul style={{ paddingLeft: 20 }}>
          <li>All prices are listed in US Dollars (USD).</li>
          <li>Prices are subject to change without notice.</li>
          <li>Product images are for illustration purposes; slight variations in color or appearance may occur.</li>
          <li>We reserve the right to limit quantities and refuse service.</li>
        </ul>
      </Section>

      <Section title="3. Orders and Payment">
        <ul style={{ paddingLeft: 20 }}>
          <li>Orders are confirmed once payment is successfully processed.</li>
          <li>We accept major credit/debit cards via Stripe.</li>
          <li>By placing an order, you confirm that the payment information provided is accurate.</li>
          <li>StyleMe reserves the right to cancel any order due to pricing errors, stock issues, or suspected fraud.</li>
        </ul>
      </Section>

      <Section title="4. Shipping">
        <ul style={{ paddingLeft: 20 }}>
          <li>We ship within the United States.</li>
          <li>Standard shipping: 2–7 business days after order processing.</li>
          <li>Shipping charges are non-refundable unless the return is due to our error.</li>
          <li>StyleMe is not responsible for delays caused by carriers or customs.</li>
        </ul>
      </Section>

      <Section title="5. Returns and Refunds">
        <p>Please see our <a href="/returns">Returns & Refunds Policy</a> for full details. In summary, most items may be returned within 30 days of delivery in original condition.</p>
      </Section>

      <Section title="6. Intellectual Property">
        <p>All content on StyleMe — including logos, product images, and text — is the property of StyleMe or its content suppliers and is protected by applicable intellectual property laws. You may not reproduce or distribute any content without written permission.</p>
      </Section>

      <Section title="7. Limitation of Liability">
        <p>StyleMe shall not be liable for any indirect, incidental, special, or consequential damages arising from the use of our products or website. Our maximum liability is limited to the amount paid for the order in question.</p>
      </Section>

      <Section title="8. Governing Law">
        <p>These terms are governed by the laws of the United States. Any disputes shall be resolved through binding arbitration.</p>
      </Section>

      <Section title="9. Changes to Terms">
        <p>We reserve the right to update these terms at any time. Continued use of our website after changes constitutes acceptance of the new terms.</p>
      </Section>

      <Section title="10. Contact">
        <p>📧 <a href="mailto:support@styleme.club">support@styleme.club</a></p>
      </Section>
    </div>
  );
}
